import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { UserService } from 'src/services/user.service';
import { LocalizationService } from 'src/services/localization.service';

@Component({
  standalone: false,
  selector: 'app-candidate-activities',
  templateUrl: './candidate-activities.component.html',
  styleUrls: ['./candidate-activities.component.scss']
})
export class CandidateActivitiesComponent implements OnInit, OnChanges {

  @Input()
  candidate: any;

  @Input()
  project: any;

  activitiesUri: string;

  mentionsUri: string;

  isReadOnly = false;

  constructor(public userService: UserService, public loc: LocalizationService) { }

  ngOnInit(): void {
  }

  ngOnChanges() {
    if (!this.candidate) return;

    // without a project the candidate is reached through the company pool, so the
    // feed reports everything that happened to them, read only
    if (!this.project)
    {
      this.isReadOnly = true;
      this.activitiesUri = `candidates/${this.candidate.Id}/activities`;
      this.mentionsUri = null;
    }

    if (this.project) {
      this.isReadOnly = false;
      this.activitiesUri = `projects/${this.project.Id}/candidates/${this.candidate.Id}/activities`;
      this.mentionsUri = `projects/${this.project.Id}/mentions`;
    }
  }

}
